var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c("div", [_c("top-title", [_c("span", {
    attrs: {
      slot: "title"
    },
    slot: "title"
  }, [_vm._v(_vm._s(_vm.$t("基本信息")))])]), _c("a-form-model", {
    ref: "ruleForm",
    attrs: {
      model: _vm.form,
      rules: _vm.rules,
      "label-col": {
        span: 4
      },
      "wrapper-col": {
        span: 16
      }
    }
  }, [_c("a-row", [_c("a-col", {
    attrs: {
      span: 12
    }
  }, [_c("a-form-model-item", {
    attrs: {
      label: _vm.$t("合同编号")
    }
  }, [_c("a-input", {
    attrs: {
      placeholder: _vm.$t("请输入") + _vm.$t("合同编号"),
      allowClear: "",
      maxLength: 100,
      disabled: _vm.disabled
    },
    model: {
      value: _vm.form.contractNo,
      callback: function ($$v) {
        _vm.$set(_vm.form, "contractNo", $$v);
      },
      expression: "form.contractNo"
    }
  })], 1)], 1), _c("a-col", {
    attrs: {
      span: 12
    }
  }, [_c("a-form-model-item", {
    attrs: {
      label: _vm.$t("合作方"),
      prop: "partner"
    }
  }, [_c("a-input", {
    attrs: {
      placeholder: _vm.$t("请输入") + _vm.$t("合作方"),
      allowClear: "",
      maxLength: 100,
      disabled: _vm.disabled
    },
    model: {
      value: _vm.form.partner,
      callback: function ($$v) {
        _vm.$set(_vm.form, "partner", $$v);
      },
      expression: "form.partner"
    }
  })], 1)], 1), _c("a-col", {
    attrs: {
      span: 12
    }
  }, [_c("a-form-model-item", {
    attrs: {
      label: _vm.$t("合同类型"),
      prop: "type"
    }
  }, [_c("a-select", {
    attrs: {
      placeholder: _vm.$t("请选择") + _vm.$t("合同类型"),
      allowClear: "",
      disabled: _vm.disabled
    },
    model: {
      value: _vm.form.type,
      callback: function ($$v) {
        _vm.$set(_vm.form, "type", $$v);
      },
      expression: "form.type"
    }
  }, _vm._l(_vm.typeList, function (item, index) {
    return _c("a-select-option", {
      key: index,
      attrs: {
        value: item.id
      }
    }, [_vm._v(_vm._s(_vm.$t(item.name)))]);
  }), 1)], 1)], 1), _c("a-col", {
    attrs: {
      span: 12
    }
  }, [_c("a-form-model-item", {
    attrs: {
      label: _vm.$t("签约类型"),
      prop: "contractType"
    }
  }, [_c("a-select", {
    attrs: {
      placeholder: _vm.$t("请选择") + _vm.$t("签约类型"),
      allowClear: "",
      disabled: _vm.disabled
    },
    model: {
      value: _vm.form.contractType,
      callback: function ($$v) {
        _vm.$set(_vm.form, "contractType", $$v);
      },
      expression: "form.contractType"
    }
  }, [_c("a-select-option", {
    attrs: {
      value: 1
    }
  }, [_vm._v(_vm._s(_vm.$t("两方协议")))]), _c("a-select-option", {
    attrs: {
      value: 2
    }
  }, [_vm._v(_vm._s(_vm.$t("三方协议")))]), _c("a-select-option", {
    attrs: {
      value: 3
    }
  }, [_vm._v(_vm._s(_vm.$t("四方协议")))])], 1)], 1)], 1), _c("a-col", {
    attrs: {
      span: 12
    }
  }, [_c("a-form-model-item", {
    attrs: {
      label: _vm.$t("有效期"),
      prop: "startTime"
    }
  }, [_c("a-range-picker", {
    staticStyle: {
      width: "100%"
    },
    attrs: {
      allowClear: "",
      format: _vm.getFormatDate(),
      disabled: _vm.disabled
    },
    model: {
      value: _vm.startTime,
      callback: function ($$v) {
        _vm.startTime = $$v;
      },
      expression: "startTime"
    }
  })], 1)], 1), _c("a-col", {
    attrs: {
      span: 12
    }
  }, [_c("a-form-model-item", {
    attrs: {
      label: _vm.$t("签约日期"),
      prop: "contractAt"
    }
  }, [_c("a-date-picker", {
    staticStyle: {
      width: "100%"
    },
    attrs: {
      allowClear: "",
      format: _vm.getFormatDate(),
      disabled: _vm.disabled
    },
    model: {
      value: _vm.form.contractAt,
      callback: function ($$v) {
        _vm.$set(_vm.form, "contractAt", $$v);
      },
      expression: "form.contractAt"
    }
  })], 1)], 1), _c("a-col", {
    attrs: {
      span: 12
    }
  }, [_c("a-form-model-item", {
    attrs: {
      label: _vm.$t("合同说明")
    }
  }, [_c("a-input", {
    attrs: {
      placeholder: _vm.$t("请输入") + _vm.$t("合同说明"),
      allowClear: "",
      disabled: _vm.disabled
    },
    model: {
      value: _vm.form.statement,
      callback: function ($$v) {
        _vm.$set(_vm.form, "statement", $$v);
      },
      expression: "form.statement"
    }
  })], 1)], 1), _vm.form.status == 2 && _vm.disabled ? _c("a-col", {
    attrs: {
      span: 12
    }
  }, [_c("a-form-model-item", {
    attrs: {
      label: _vm.$t("合同终止时间")
    }
  }, [_c("a-input", {
    attrs: {
      placeholder: _vm.$t("请输入") + _vm.$t("合同说明"),
      allowClear: "",
      disabled: _vm.disabled
    },
    model: {
      value: _vm.form.stopAt,
      callback: function ($$v) {
        _vm.$set(_vm.form, "stopAt", $$v);
      },
      expression: "form.stopAt"
    }
  })], 1)], 1) : _vm._e(), _vm.form.status == 2 && _vm.disabled ? _c("a-col", {
    attrs: {
      span: 12
    }
  }, [_c("a-form-model-item", {
    attrs: {
      label: _vm.$t("合同终止原因")
    }
  }, [_c("a-input", {
    attrs: {
      placeholder: _vm.$t("请输入") + _vm.$t("合同说明"),
      allowClear: "",
      disabled: _vm.disabled
    },
    model: {
      value: _vm.form.reason,
      callback: function ($$v) {
        _vm.$set(_vm.form, "reason", $$v);
      },
      expression: "form.reason"
    }
  })], 1)], 1) : _vm._e()], 1), _c("a-row", [_c("a-col", {
    attrs: {
      span: 12
    }
  }, [_c("a-form-model-item", {
    attrs: {
      label: _vm.$t("合同附件"),
      prop: "appendix"
    }
  }, [_c("a-upload", {
    staticClass: "upload-list-inline",
    attrs: {
      action: _vm.action,
      multiple: true,
      "file-list": _vm.fileList,
      accept: "image/*,.pdf",
      "list-type": "picture",
      data: {
        module: "contract"
      },
      showUploadList: {
        showPreviewIcon: true,
        showRemoveIcon: _vm.type == 1 ? false : true
      },
      headers: {
        "X-Dispatch": "Upload",
        "X-Version": "upload"
      }
    },
    on: {
      change: _vm.handleChange,
      preview: _vm.handlePreview
    }
  }, [_vm.type != 1 ? _c("a-button", {
    attrs: {
      icon: "plus"
    }
  }, [_vm._v(_vm._s(_vm.$t("选择文件")))]) : _vm._e()], 1), !_vm.disabled ? _c("div", [_vm._v("*" + _vm._s(_vm.$t("仅支持上传jpg，pdf，png，jpeg，bmp格式文件，最大不超30M")))]) : _vm._e()], 1)], 1)], 1)], 1), _vm.form.contractType ? _c("top-title", [_c("span", {
    attrs: {
      slot: "title"
    },
    slot: "title"
  }, [_vm._v(_vm._s(_vm.$t("甲方")))])]) : _vm._e(), _vm.form.contractType ? _c("a-form-model", {
    ref: "partyAForm",
    attrs: {
      model: _vm.partyAForm,
      rules: _vm.partyARules,
      "label-col": {
        span: 4
      },
      "wrapper-col": {
        span: 16
      }
    }
  }, [_c("a-row", [_c("a-col", {
    attrs: {
      span: 12
    }
  }, [_c("a-form-model-item", {
    attrs: {
      label: _vm.$t("甲方名称"),
      prop: "name"
    }
  }, [_c("a-input", {
    attrs: {
      allowClear: "",
      disabled: _vm.disabled
    },
    model: {
      value: _vm.partyAForm.name,
      callback: function ($$v) {
        _vm.$set(_vm.partyAForm, "name", $$v);
      },
      expression: "partyAForm.name"
    }
  })], 1)], 1), _c("a-col", {
    attrs: {
      span: 12
    }
  }, [_c("a-form-model-item", {
    attrs: {
      label: _vm.$t("法人代表")
    }
  }, [_c("a-input", {
    attrs: {
      allowClear: "",
      disabled: _vm.disabled
    },
    model: {
      value: _vm.partyAForm.legal,
      callback: function ($$v) {
        _vm.$set(_vm.partyAForm, "legal", $$v);
      },
      expression: "partyAForm.legal"
    }
  })], 1)], 1), _c("a-col", {
    attrs: {
      span: 12
    }
  }, [_c("a-form-model-item", {
    attrs: {
      label: _vm.$t("联系人")
    }
  }, [_c("a-input", {
    attrs: {
      allowClear: "",
      disabled: _vm.disabled
    },
    model: {
      value: _vm.partyAForm.principal,
      callback: function ($$v) {
        _vm.$set(_vm.partyAForm, "principal", $$v);
      },
      expression: "partyAForm.principal"
    }
  })], 1)], 1), _c("a-col", {
    attrs: {
      span: 12
    }
  }, [_c("a-form-model-item", {
    attrs: {
      label: _vm.$t("联系方式"),
      "validate-status": _vm.partyAPhone,
      help: _vm.partyAPhone == "error" ? _vm.$t("请输入") + _vm.$t("正确的联系方式") : ""
    }
  }, [_c("a-input", {
    attrs: {
      allowClear: "",
      disabled: _vm.disabled
    },
    model: {
      value: _vm.partyAForm.mobile,
      callback: function ($$v) {
        _vm.$set(_vm.partyAForm, "mobile", $$v);
      },
      expression: "partyAForm.mobile"
    }
  })], 1)], 1), _c("a-col", {
    attrs: {
      span: 12
    }
  }, [_c("a-form-model-item", {
    attrs: {
      label: _vm.$t("电子邮箱"),
      "validate-status": _vm.partyAEmail,
      help: _vm.partyAEmail == "error" ? _vm.$t("请输入") + _vm.$t("正确的电子邮箱") : ""
    }
  }, [_c("a-input", {
    attrs: {
      allowClear: "",
      disabled: _vm.disabled
    },
    model: {
      value: _vm.partyAForm.email,
      callback: function ($$v) {
        _vm.$set(_vm.partyAForm, "email", $$v);
      },
      expression: "partyAForm.email"
    }
  })], 1)], 1), _c("a-col", {
    attrs: {
      span: 12
    }
  }, [_c("a-form-model-item", {
    attrs: {
      label: _vm.$t("地址")
    }
  }, [_c("a-input", {
    attrs: {
      allowClear: "",
      disabled: _vm.disabled
    },
    model: {
      value: _vm.partyAForm.address,
      callback: function ($$v) {
        _vm.$set(_vm.partyAForm, "address", $$v);
      },
      expression: "partyAForm.address"
    }
  })], 1)], 1)], 1)], 1) : _vm._e(), _vm.form.contractType ? _c("top-title", [_c("span", {
    attrs: {
      slot: "title"
    },
    slot: "title"
  }, [_vm._v(_vm._s(_vm.$t("乙方")))])]) : _vm._e(), _vm.form.contractType ? _c("a-form-model", {
    ref: "partyBForm",
    attrs: {
      model: _vm.partyBForm,
      rules: _vm.partyBRules,
      "label-col": {
        span: 4
      },
      "wrapper-col": {
        span: 16
      }
    }
  }, [_c("a-row", [_c("a-col", {
    attrs: {
      span: 12
    }
  }, [_c("a-form-model-item", {
    attrs: {
      label: _vm.$t("乙方名称"),
      prop: "name"
    }
  }, [_c("a-input", {
    attrs: {
      allowClear: "",
      disabled: _vm.disabled
    },
    model: {
      value: _vm.partyBForm.name,
      callback: function ($$v) {
        _vm.$set(_vm.partyBForm, "name", $$v);
      },
      expression: "partyBForm.name"
    }
  })], 1)], 1), _c("a-col", {
    attrs: {
      span: 12
    }
  }, [_c("a-form-model-item", {
    attrs: {
      label: _vm.$t("法人代表")
    }
  }, [_c("a-input", {
    attrs: {
      allowClear: "",
      disabled: _vm.disabled
    },
    model: {
      value: _vm.partyBForm.legal,
      callback: function ($$v) {
        _vm.$set(_vm.partyBForm, "legal", $$v);
      },
      expression: "partyBForm.legal"
    }
  })], 1)], 1), _c("a-col", {
    attrs: {
      span: 12
    }
  }, [_c("a-form-model-item", {
    attrs: {
      label: _vm.$t("联系人")
    }
  }, [_c("a-input", {
    attrs: {
      allowClear: "",
      disabled: _vm.disabled
    },
    model: {
      value: _vm.partyBForm.principal,
      callback: function ($$v) {
        _vm.$set(_vm.partyBForm, "principal", $$v);
      },
      expression: "partyBForm.principal"
    }
  })], 1)], 1), _c("a-col", {
    attrs: {
      span: 12
    }
  }, [_c("a-form-model-item", {
    attrs: {
      label: _vm.$t("联系方式"),
      "validate-status": _vm.partyBPhone,
      help: _vm.partyBPhone == "error" ? _vm.$t("请输入") + _vm.$t("正确的联系方式") : ""
    }
  }, [_c("a-input", {
    attrs: {
      allowClear: "",
      disabled: _vm.disabled
    },
    model: {
      value: _vm.partyBForm.mobile,
      callback: function ($$v) {
        _vm.$set(_vm.partyBForm, "mobile", $$v);
      },
      expression: "partyBForm.mobile"
    }
  })], 1)], 1), _c("a-col", {
    attrs: {
      span: 12
    }
  }, [_c("a-form-model-item", {
    attrs: {
      label: _vm.$t("电子邮箱"),
      "validate-status": _vm.partyBEmail,
      help: _vm.partyBEmail == "error" ? _vm.$t("请输入") + _vm.$t("正确的电子邮箱") : ""
    }
  }, [_c("a-input", {
    attrs: {
      allowClear: "",
      disabled: _vm.disabled
    },
    model: {
      value: _vm.partyBForm.email,
      callback: function ($$v) {
        _vm.$set(_vm.partyBForm, "email", $$v);
      },
      expression: "partyBForm.email"
    }
  })], 1)], 1), _c("a-col", {
    attrs: {
      span: 12
    }
  }, [_c("a-form-model-item", {
    attrs: {
      label: _vm.$t("地址")
    }
  }, [_c("a-input", {
    attrs: {
      allowClear: "",
      disabled: _vm.disabled
    },
    model: {
      value: _vm.partyBForm.address,
      callback: function ($$v) {
        _vm.$set(_vm.partyBForm, "address", $$v);
      },
      expression: "partyBForm.address"
    }
  })], 1)], 1)], 1)], 1) : _vm._e(), _vm.form.contractType && _vm.form.contractType != 1 ? _c("top-title", [_c("span", {
    attrs: {
      slot: "title"
    },
    slot: "title"
  }, [_vm._v(_vm._s(_vm.$t("丙方")))])]) : _vm._e(), _vm.form.contractType && _vm.form.contractType != 1 ? _c("a-form-model", {
    ref: "partyCForm",
    attrs: {
      model: _vm.partyCForm,
      rules: _vm.partyCRules,
      "label-col": {
        span: 4
      },
      "wrapper-col": {
        span: 16
      }
    }
  }, [_c("a-row", [_c("a-col", {
    attrs: {
      span: 12
    }
  }, [_c("a-form-model-item", {
    attrs: {
      label: _vm.$t("丙方名称"),
      prop: "name"
    }
  }, [_c("a-input", {
    attrs: {
      allowClear: "",
      disabled: _vm.disabled
    },
    model: {
      value: _vm.partyCForm.name,
      callback: function ($$v) {
        _vm.$set(_vm.partyCForm, "name", $$v);
      },
      expression: "partyCForm.name"
    }
  })], 1)], 1), _c("a-col", {
    attrs: {
      span: 12
    }
  }, [_c("a-form-model-item", {
    attrs: {
      label: _vm.$t("法人代表")
    }
  }, [_c("a-input", {
    attrs: {
      allowClear: "",
      disabled: _vm.disabled
    },
    model: {
      value: _vm.partyCForm.legal,
      callback: function ($$v) {
        _vm.$set(_vm.partyCForm, "legal", $$v);
      },
      expression: "partyCForm.legal"
    }
  })], 1)], 1), _c("a-col", {
    attrs: {
      span: 12
    }
  }, [_c("a-form-model-item", {
    attrs: {
      label: _vm.$t("联系人")
    }
  }, [_c("a-input", {
    attrs: {
      allowClear: "",
      disabled: _vm.disabled
    },
    model: {
      value: _vm.partyCForm.principal,
      callback: function ($$v) {
        _vm.$set(_vm.partyCForm, "principal", $$v);
      },
      expression: "partyCForm.principal"
    }
  })], 1)], 1), _c("a-col", {
    attrs: {
      span: 12
    }
  }, [_c("a-form-model-item", {
    attrs: {
      label: _vm.$t("联系方式"),
      "validate-status": _vm.partyCPhone,
      help: _vm.partyCPhone == "error" ? _vm.$t("请输入") + _vm.$t("正确的联系方式") : ""
    }
  }, [_c("a-input", {
    attrs: {
      allowClear: "",
      disabled: _vm.disabled
    },
    model: {
      value: _vm.partyCForm.mobile,
      callback: function ($$v) {
        _vm.$set(_vm.partyCForm, "mobile", $$v);
      },
      expression: "partyCForm.mobile"
    }
  })], 1)], 1), _c("a-col", {
    attrs: {
      span: 12
    }
  }, [_c("a-form-model-item", {
    attrs: {
      label: _vm.$t("电子邮箱"),
      "validate-status": _vm.partyCEmail,
      help: _vm.partyCEmail == "error" ? _vm.$t("请输入") + _vm.$t("正确的电子邮箱") : ""
    }
  }, [_c("a-input", {
    attrs: {
      allowClear: "",
      disabled: _vm.disabled
    },
    model: {
      value: _vm.partyCForm.email,
      callback: function ($$v) {
        _vm.$set(_vm.partyCForm, "email", $$v);
      },
      expression: "partyCForm.email"
    }
  })], 1)], 1), _c("a-col", {
    attrs: {
      span: 12
    }
  }, [_c("a-form-model-item", {
    attrs: {
      label: _vm.$t("地址")
    }
  }, [_c("a-input", {
    attrs: {
      allowClear: "",
      disabled: _vm.disabled
    },
    model: {
      value: _vm.partyCForm.address,
      callback: function ($$v) {
        _vm.$set(_vm.partyCForm, "address", $$v);
      },
      expression: "partyCForm.address"
    }
  })], 1)], 1)], 1)], 1) : _vm._e(), _vm.form.contractType && _vm.form.contractType == 3 ? _c("top-title", [_c("span", {
    attrs: {
      slot: "title"
    },
    slot: "title"
  }, [_vm._v(_vm._s(_vm.$t("丁方")))])]) : _vm._e(), _vm.form.contractType && _vm.form.contractType == 3 ? _c("a-form-model", {
    ref: "partyDForm",
    attrs: {
      model: _vm.partyDForm,
      rules: _vm.partyDRules,
      "label-col": {
        span: 4
      },
      "wrapper-col": {
        span: 16
      }
    }
  }, [_c("a-row", [_c("a-col", {
    attrs: {
      span: 12
    }
  }, [_c("a-form-model-item", {
    attrs: {
      label: _vm.$t("丙方名称"),
      prop: "name"
    }
  }, [_c("a-input", {
    attrs: {
      allowClear: "",
      disabled: _vm.disabled
    },
    model: {
      value: _vm.partyDForm.name,
      callback: function ($$v) {
        _vm.$set(_vm.partyDForm, "name", $$v);
      },
      expression: "partyDForm.name"
    }
  })], 1)], 1), _c("a-col", {
    attrs: {
      span: 12
    }
  }, [_c("a-form-model-item", {
    attrs: {
      label: _vm.$t("法人代表")
    }
  }, [_c("a-input", {
    attrs: {
      allowClear: "",
      disabled: _vm.disabled
    },
    model: {
      value: _vm.partyDForm.legal,
      callback: function ($$v) {
        _vm.$set(_vm.partyDForm, "legal", $$v);
      },
      expression: "partyDForm.legal"
    }
  })], 1)], 1), _c("a-col", {
    attrs: {
      span: 12
    }
  }, [_c("a-form-model-item", {
    attrs: {
      label: _vm.$t("联系人")
    }
  }, [_c("a-input", {
    attrs: {
      allowClear: "",
      disabled: _vm.disabled
    },
    model: {
      value: _vm.partyDForm.principal,
      callback: function ($$v) {
        _vm.$set(_vm.partyDForm, "principal", $$v);
      },
      expression: "partyDForm.principal"
    }
  })], 1)], 1), _c("a-col", {
    attrs: {
      span: 12
    }
  }, [_c("a-form-model-item", {
    attrs: {
      label: _vm.$t("联系方式"),
      "validate-status": _vm.partyDPhone,
      help: _vm.partyDPhone == "error" ? _vm.$t("请输入") + _vm.$t("正确的联系方式") : ""
    }
  }, [_c("a-input", {
    attrs: {
      allowClear: "",
      disabled: _vm.disabled
    },
    model: {
      value: _vm.partyDForm.mobile,
      callback: function ($$v) {
        _vm.$set(_vm.partyDForm, "mobile", $$v);
      },
      expression: "partyDForm.mobile"
    }
  })], 1)], 1), _c("a-col", {
    attrs: {
      span: 12
    }
  }, [_c("a-form-model-item", {
    attrs: {
      label: _vm.$t("电子邮箱"),
      "validate-status": _vm.partyDEmail,
      help: _vm.partyDEmail == "error" ? _vm.$t("请输入") + _vm.$t("正确的电子邮箱") : ""
    }
  }, [_c("a-input", {
    attrs: {
      allowClear: "",
      disabled: _vm.disabled
    },
    model: {
      value: _vm.partyDForm.email,
      callback: function ($$v) {
        _vm.$set(_vm.partyDForm, "email", $$v);
      },
      expression: "partyDForm.email"
    }
  })], 1)], 1), _c("a-col", {
    attrs: {
      span: 12
    }
  }, [_c("a-form-model-item", {
    attrs: {
      label: _vm.$t("地址")
    }
  }, [_c("a-input", {
    attrs: {
      allowClear: "",
      disabled: _vm.disabled
    },
    model: {
      value: _vm.partyDForm.address,
      callback: function ($$v) {
        _vm.$set(_vm.partyDForm, "address", $$v);
      },
      expression: "partyDForm.address"
    }
  })], 1)], 1)], 1)], 1) : _vm._e(), _vm.type != 1 ? _c("div", {
    staticStyle: {
      display: "flex",
      "justify-content": "center"
    }
  }, [_c("a-button", {
    attrs: {
      type: "add",
      loading: _vm.loading
    },
    on: {
      click: _vm.nextFun
    }
  }, [_vm._v(_vm._s(_vm.$t("下一步")))])], 1) : _vm._e(), _c("a-modal", {
    attrs: {
      visible: _vm.previewVisible,
      footer: null,
      width: 800
    },
    on: {
      cancel: _vm.handleCancel
    }
  }, [_c("img", {
    staticStyle: {
      width: "100%"
    },
    attrs: {
      alt: "example",
      src: _vm.previewImage
    }
  })])], 1);
};
var staticRenderFns = [];
render._withStripped = true;
export { render, staticRenderFns };